var React = require('react');

function GiftNew (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4","y":"13","width":"26","height":"19","strokeWidth":"3","strokeLinejoin":"round","key":0}),React.createElement("rect",{"x":"2","y":"6.83203","width":"30","height":"6","strokeWidth":"3","strokeLinejoin":"round","key":1}),React.createElement("rect",{"x":"20","y":"7","width":"25","height":"6","transform":"rotate(90 20 7)","strokeWidth":"3","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M15.9998 6.33052C12.9981 -0.167836 8.5 1.32914 10.4998 6.33052","strokeWidth":"3","strokeLinejoin":"round","key":3}),React.createElement("path",{"d":"M18.0002 6.33052C21.0019 -0.167836 25.5 1.32914 23.5002 6.33052","strokeWidth":"3","strokeLinejoin":"round","key":4})]);
}

GiftNew.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = GiftNew;

GiftNew.default = GiftNew;
